import { InputAddressData } from '@afterpaytouch/core'
import { Validate } from 'react-hook-form'
import { isConsumerLendingEligibleState } from '../../utils/profile-validation'
import { IdentityVerificationForm } from './types'

export const validateIneligibleStates = (message: string): Record<string, Validate<InputAddressData, IdentityVerificationForm>> => {
  return {
    ineligibleState: (address) => {
      return isConsumerLendingEligibleState(address) || message
    },
  }
}
